export default __webpack_public_path__ + "static/media/infoIcon.ec53ee17.svg";